import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import AllSubjectsBanner from "../../Components/AllSubjectsBanner";
import ChatHelpExperts from "../../Components/ChatHelpExperts";
import StudentStories from "../../Components/StudentStories";
import ScrollTop from "../../Components/Buttons/ScrollTop";
import Hashtags from "../../Components/Hashtags";
import CommonForm from "../HomePage/Form/CommonForm";
import { getSubjectBySlug } from "../../services/getSubjectBySlug";
import { toast } from "react-toastify";
import AllSubjectsReadMoresec from "../../Components/AllSubjectsReadMoresec";
import RecentlyAskedQueSubject from "../../Components/RecentlyAskedQueSubject";
import { Helmet } from "react-helmet";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";

const SubjectCategory = () => {
  const subCategoryId = "655659b9b9cbef8acade1d7c";
  const [isModelOpen, setIsModelOpen] = useState(false);
  const toggle = () => setIsModelOpen(!isModelOpen);
  const { slug } = useParams();
  const [data, setData] = useState({});
  const [reletedSubjects, setReletedSubjects] = useState([]);


  const fetchData = async () => {
    try {
      const response = await getSubjectBySlug(slug);
      if (response.isSuccess) {
        setData(response.data);
        const relatedSubjects = response?.reletedSubjects;
        setReletedSubjects(relatedSubjects);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch data");
    }
  };

  useEffect(() => {
    fetchData();
  }, [slug]);


  const breadCrumbData=[
     { label: "Home", path: "/" },
    { label: data?.questionSubject},
  ]
  return (
    <>
      {/* <Nav />
      <Navbar /> */}
      <Helmet>
        <title>{`Expert ${data?.questionSubject} Assignment & Homework Help | Get Personalized Academic Success with DoubtQ`}</title>

        <meta
          name="description"
          content={`Get professional assistance with your ${data?.questionSubject} assignments and homework from top tutors. Receive expert guidance, timely solutions, and high-quality support to help you excel in your studies!`}
        />

        <meta
          property="og:title"
          content={`${data?.questionSubject} Page - DoubtQ`}
        />

        <meta
          property="og:description"
          content={`Get professional assistance with your ${data?.questionSubject} assignments and homework from top tutors. Receive expert guidance, timely solutions, and high-quality support to help you excel in your studies!`}
        />
      </Helmet>

       <div className="container">
      <div className="row mt-2 mb-2 m-0">
        <BreadCrumb items={breadCrumbData} />
      </div>
      </div>

      <AllSubjectsBanner setIsModelOpen={setIsModelOpen} data={data} />
      <RecentlyAskedQueSubject subjectId={data?._id} />

      {  reletedSubjects?.length > 0 && (
      <div className="container" style={{ paddingTop: "70px" }}>
        <h2 className="title">Trending subjects for  {data?.questionSubject?.replace(" Homework Help", "")}</h2>
        <p className="description">
          You can get the best rated step-by-step problem explanation from
          65000+ expert tutors by ordering DoubtQ {data?.questionSubject}
        </p>
            <Hashtags reletedSubjects={reletedSubjects}/>
      </div>
        )}
      
      <StudentStories />
      {/* <ChatHelpExperts /> */}
      {data?.description && <AllSubjectsReadMoresec data={data} />}
      {isModelOpen && (
        <CommonForm
          isOpen={isModelOpen}
          toggle={toggle}
          typeData={{
            serviceType: "AssignmentHelp",
            type: "assignmentHelp",
            totalSteps:1,
          }}
          subCategory={subCategoryId}
        />
      )}
      <ScrollTop />
    </>
  );
};

export default SubjectCategory;
